import { combineReducers } from 'redux';
import { REHYDRATE } from 'redux-persist';
// Import existing reducers
import profile from 'reducers/slices/profile';
import idprovider from 'reducers/slices/idprovider';
import deeplink from 'reducers/slices/deeplink';
import intro from 'reducers/slices/intro';
import sidebar from 'reducers/slices/sidebar';
import flip from 'reducers/slices/flip';
import cardindex from 'reducers/slices/cardindex';
import controls from 'reducers/slices/controls';
import calendarstatus from 'reducers/slices/calendarstatus';
import readstatus from 'reducers/slices/readstatus';
import readswitchstatus from 'reducers/slices/readswitchstatus';
import hskstatus from 'reducers/slices/hskstatus';
import catsstatus from 'reducers/slices/catsstatus';
import loginstatus from 'reducers/slices/loginstatus';
import paymentstatus from 'reducers/slices/paymentstatus';
import charstatus from 'reducers/slices/charstatus';
import sentencestatus from 'reducers/slices/sentencestatus';
import colorstatus from 'reducers/slices/colorstatus';
import quizstatus from 'reducers/slices/quizstatus';
import articleapi from 'reducers/slices/articleapi';
import resetdate from 'reducers/slices/resetdate';
import date from 'reducers/slices/date';
import dictionary from 'reducers/slices/dictionary';
import words from 'reducers/slices/words';
import bookmarks from 'reducers/slices/bookmarks';
import readarticles from 'reducers/slices/readarticles';
import sentences from 'reducers/slices/sentences';
import faux from 'reducers/slices/faux';
import categories from 'reducers/slices/categories';
import currentchar from 'reducers/slices/currentchar';
import collapsesettings from 'reducers/slices/collapsesettings';

// Import new settings slices
import uisettings from 'reducers/slices/uisettings';
import languagesettings from 'reducers/slices/languagesettings';
import audiosettings from 'reducers/slices/audiosettings';
import colorsettings from 'reducers/slices/colorsettings';
import quizsettings from 'reducers/slices/quizsettings';
import skillsettings from 'reducers/slices/skillsettings';
import datesettings from 'reducers/slices/datesettings';
import { GraphQLAPI } from 'utils/RTKGraphQL';
export default () => {
  // Return a function that first handles migration, then applies the regular combineReducers
  return (state = {}, action) => {
    // Handle migration from old settings to new slices
    if (action.type === REHYDRATE && action.payload && action.payload.settings) {
      const oldSettings = action.payload.settings;

      // Only migrate if we have old settings but not the new slices
      if (!action.payload.languagesettings || !action.payload.uisettings || !action.payload.skillsettings || !action.payload.quizsettings) {
        // Create a new state object with migrated settings
        state = {
          ...state,
          // Copy values from old settings to new slices
          languagesettings: {
            traditional: oldSettings.traditional ?? false,
            showPinyin: oldSettings.showPinyin ?? true,
            showRead: oldSettings.showRead ?? false
          },
          uisettings: {
            pinyinSize: oldSettings.pinyinSize ?? 0,
            charSize: oldSettings.charSize ?? 0
          },
          skillsettings: {
            skill: oldSettings.skill ?? [],
            cats: oldSettings.cats ?? [],
            skillSelected: oldSettings.skillSelected ?? 0
          },
          quizsettings: {
            wordSelection: oldSettings.wordSelection ?? 0,
            limitSelection: oldSettings.limitSelection ?? 2,
            showCharacter: oldSettings.showCharacter ?? false,
            showOutline: oldSettings.showOutline ?? true,
            showHintAfterMiss: oldSettings.showHintAfterMiss ?? 3
          },
          colorsettings: {
            colorScheme: oldSettings.colorScheme ?? 'system'
          },
          audiosettings: {
            autoPlay: oldSettings.autoPlay ?? false
          },
          datesettings: {
            // Map any date-related settings
          }
        };
      }
    }

    // Use the combined reducers with the potentially migrated state
    const combinedReducer = combineReducers({
      [GraphQLAPI.reducerPath]: GraphQLAPI.reducer,
      categories,
      profile,
      idprovider,
      deeplink,
      intro,
      sidebar,
      flip,
      cardindex,
      controls,
      collapsesettings,
      calendarstatus,
      readstatus,
      hskstatus,
      catsstatus,
      loginstatus,
      paymentstatus,
      readswitchstatus,
      charstatus,
      sentencestatus,
      colorstatus,
      quizstatus,
      articleapi,
      resetdate,
      date,
      dictionary,
      words,
      bookmarks,
      sentences,
      readarticles,
      faux,
      currentchar,
      // New settings slices - replace the single settings reducer
      uisettings,
      languagesettings,
      audiosettings,
      colorsettings,
      quizsettings,
      skillsettings,
      datesettings,
      // Router-related reducers
      length: (state = {}) => state,
      action: (state = {}) => state,
      index: (state = {}) => state,
      entries: (state = {}) => state,
      location: (state = {}) => state,
      createHref: (state = {}) => state,
      push: (state = {}) => state,
      replace: (state = {}) => state,
      go: (state = {}) => state,
      goBack: (state = {}) => state,
      goForward: (state = {}) => state,
      canGo: (state = {}) => state,
      block: (state = {}) => state,
      listen: (state = {}) => state
    });
    return combinedReducer(state, action);
  };
};